import '../../App.css';
import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { FaTimes, FaPlus, FaImage } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { SlOptionsVertical } from 'react-icons/sl';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';
import { ApiContext } from '../../context/ApiContext';
import SelectMultiplo, { paraOpcoes, comoEvento } from '../SelectMultiplo';
import moment from 'moment';
import Cookies from 'js-cookie'

function ModalCadastrarServico({ closeModal, currentPage }) {
    const { CadastrarServico, CadastroServico, setCadastroServico, ListaGrupo, Grupos, FormAnexoServico, setFormAnexoServico, ServicoSubgrupo, RetornaSubgrupo, ListaTipoServico, RetornaItem, ServicoItem, ListaSLA, SLAs, ListaPeriodicidade, Periodicidades, ListaCobertura, Coberturas, TiposServico, FormLink, setFormLink, ListaOrganizacao, Organizacoes, ListaPratica, Praticas, ListaFornecedor, Fornecedores, RetornaLocalidade, ServicoLocalidade, setServicoLocalidade, ListaMetodo, Metodos, setError, ListaAreaDisponivel, AreaServicoDisponivel } = useContext(ServicoContext)
    const { ListaCargo, Cargos, ListaSistemas, Sistemas, Linhas, ListaLinhaAtendimento } = useContext(ApiContext)
    const { btnVer, btnCriar, btnPesquisar } = useContext(StyleContext)
    const anexoRef = useRef()
    const sistemaRef = useRef()

    const [AddAnexo, setAddAnexo] = useState('')
    const [LinkAdd, setLinkAdd] = useState('')
    const [DescricaoAdd, setDescricaoAdd] = useState('')
    const [attLista, setattLista] = useState(false)
    const [grupoKey, setGrupoKey] = useState("")
    const [subGrupoKey, setSubGrupoKey] = useState("")
    const [itemKey, setItemKey] = useState("")
    const [organizacaoKey, setOrganizacaoKey] = useState("")
    const [sistemasSelecionados, setSistemasSelecionados] = useState([]);
    const [sistemaKey, setSistemaKey] = useState("")

    const handleChange = (event) => {
        setCadastroServico({ ...CadastroServico, [event.target.name]: event.target.value })
    }

    const handleClose = () => {
        setCadastroServico({ descricao: "" });
        setFormAnexoServico([])
        setFormLink([])
        closeModal(false);
    };

    const AdicionarAnexo = () => {
        if (!AddAnexo) {
            setError("Campo anexo em branco.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(AddAnexo);
        reader.onloadend = () => {
            let data = {
                file: reader.result.split(',')[1],
                fileName: AddAnexo.name,
                contentType: AddAnexo.type
            };

            setFormAnexoServico(FormAnexoServico => [...FormAnexoServico, data]);
            setAddAnexo(null);
            anexoRef.current.value = ""
            setattLista(!attLista);
        };
    };

    const ExcluirAnexo = (props) => {
        FormAnexoServico.splice(props, 1)
        setattLista(!attLista)
    }

    const AdicionarLink = () => {
        if (typeof LinkAdd === 'undefined' || LinkAdd === '') {
            setError("Campo link em branco.")
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        let data = {
            nome: Cookies.get("Username"),
            link: LinkAdd,
            descricao: DescricaoAdd,
        }
        setFormLink(FormLink => [...FormLink, data])
        setLinkAdd("")
        setDescricaoAdd("")
        setattLista(!attLista)
    }

    const ExcluirLink = (props) => {
        FormLink.splice(props, 1)
        setattLista(!attLista)
    }

    const AdicionarSistema = () => {
        if (!sistemaKey || sistemaKey === "0") {
            setError("Selecione uma aplicação.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        const sistema = JSON.parse(sistemaKey);

        if (sistemasSelecionados.some(item => item.id === sistema.id)) {
            const sistemasAtualizados = sistemasSelecionados.filter(item => item.id !== sistema.id);
            setSistemasSelecionados(sistemasAtualizados);
        } else {
            setSistemasSelecionados([...sistemasSelecionados, {
                sistemaKey: sistema.key,
                nome: sistema.nome,
                id: sistema.id,
            }]);
        }

        sistemaRef.current.value = 0;
        setSistemaKey("");
    };

    const ExcluirSistema = (id) => {
        const sistemaRemovido = sistemasSelecionados.find(item => item.id === id);

        if (sistemaRemovido) {
            const sistemasAtualizados = sistemasSelecionados.filter(item => item.id !== id);
            setSistemasSelecionados(sistemasAtualizados);
        }
    };

    useEffect(() => {
        ListaGrupo()
        ListaCargo()
        ListaTipoServico()
        ListaSLA()
        ListaPeriodicidade()
        ListaCobertura()
        ListaOrganizacao()
        ListaAreaDisponivel()
        ListaPratica()
        ListaFornecedor()
        ListaMetodo()
        ListaSistemas()
        setFormAnexoServico([])
        setFormLink([])
        ListaLinhaAtendimento('S')
    }, [])

    const handleGrupoChange = (e) => {
        const value = e.target.value;
        setGrupoKey(value);
        setSubGrupoKey("");
        setItemKey("");
    };

    const handleSubGrupoChange = (e) => {
        const value = e.target.value;
        setSubGrupoKey(value);
        setItemKey("");
    };

    const handleItemChange = (e) => {
        const value = e.target.value;
        setItemKey(value);
    };

    useEffect(() => {
        if (grupoKey !== "") {
            setCadastroServico((prev) => ({
                ...prev,
                grupoKey,
                subGrupoKey: "",
                itemKey: "",
            }));
            RetornaSubgrupo(grupoKey);
        }
    }, [grupoKey]);

    useEffect(() => {
        if (subGrupoKey !== "") {
            setCadastroServico((prev) => ({
                ...prev,
                subGrupoKey,
                itemKey: "",
            }));
            RetornaItem(subGrupoKey);
        }
    }, [subGrupoKey]);

    useEffect(() => {
        if (itemKey !== "") {
            setCadastroServico((prev) => ({
                ...prev,
                itemKey,
            }));
        }
    }, [itemKey]);

    const [organizacaoValue, setOrganizacaoValue] = useState([]);
    const [localidadeValue, setLocalidadeValue] = useState([]);
    const [areaValue, setAreaValue] = useState([]);
    const [praticaValue, setPraticaValue] = useState([]);
    const [fornecedorValue, setFornecedorValue] = useState([]);
    const [executorValue, setExecutorValue] = useState([]);

    const organizacaoOnChange = (event) => {
        const selectedKeys = event.target.value
        setOrganizacaoValue(selectedKeys);

        const organizacoesKeys = selectedKeys.map((key) => ({
            organizacaoKey: key,
        }));

        setCadastroServico((prev) => ({
            ...prev,
            organizacoes: organizacoesKeys,
            localidades: [],
        }));

        setServicoLocalidade([]);
    };

    const localidadeOnChange = (event) => {
        const selectedKeys = event.target.value;
        setLocalidadeValue(selectedKeys);

        const localidadesKeys = selectedKeys.map((key) => ({
            localidadeKey: key,
        }));

        setCadastroServico((prev) => ({
            ...prev,
            localidades: localidadesKeys,
        }));
    };

    const areaOnChange = (event) => {
        const selectedKeys = event.target.value;
        setAreaValue(selectedKeys);

        const areasKeys = selectedKeys.map((key) => ({
            areaKey: key,
        }));

        setCadastroServico((prev) => ({
            ...prev,
            areas: areasKeys,
        }));
    };

    const praticaOnChange = (event) => {
        const selectedKeys = event.target.value;
        setPraticaValue(selectedKeys);

        const praticaKeys = selectedKeys.map((key) => ({
            praticaReferenciaKey: key,
        }));

        setCadastroServico((prev) => ({
            ...prev,
            praticas: praticaKeys,
        }));
    };

    const fornecedorOnChange = (event) => {
        const selectedKeys = event.target.value;
        setFornecedorValue(selectedKeys);

        const fornecedorKeys = selectedKeys.map((key) => ({
            fornecedorKey: key,
        }));

        setCadastroServico((prev) => ({
            ...prev,
            fornecedores: fornecedorKeys,
        }));
    };

    const executorOnChange = (event) => {
        const selectedKeys = event.target.value;
        setExecutorValue(selectedKeys);

        const executorKeys = selectedKeys.map((key) => ({
            linhaAtendimentoKey: key,
        }));

        setCadastroServico((prev) => ({
            ...prev,
            linhasExecutores: executorKeys,
        }));
    };

    useEffect(() => {
        if (organizacaoValue.length > 0) {
            RetornaLocalidade(organizacaoValue);
        }
    }, [organizacaoValue]);

    useEffect(() => {
        setCadastroServico((prev) => ({
            ...prev,
            sistemas: sistemasSelecionados,
        }));
    }, [sistemasSelecionados]);

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Cadastrar serviço</h1>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={(e) => CadastrarServico(e, currentPage)}>
                    <div className="modal-content">
                        <Tabs className='mt-3 mb-3'>
                            <Tab eventKey="geral" title={<span>Geral</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Serviço</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="descricao" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Grupo</Form.Label>
                                            <Form.Select aria-label="Default select example" value={grupoKey} onChange={handleGrupoChange} name="grupoKey">
                                                <option value="">Selecione</option>
                                                {Grupos &&
                                                    Grupos.sort((a, b) => a?.descricao?.localeCompare(b?.descricao))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.descricao}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Subgrupo</Form.Label>
                                            <Form.Select aria-label="Default select example" value={subGrupoKey} onChange={handleSubGrupoChange} name="subGrupoKey">
                                                <option value="">Selecione</option>
                                                {ServicoSubgrupo &&
                                                    ServicoSubgrupo.sort((a, b) => a?.descricao?.localeCompare(b?.descricao))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.descricao}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Item</Form.Label>
                                            <Form.Select aria-label="Default select example" value={itemKey} onChange={handleItemChange} name="itemKey">
                                                <option value="">Selecione</option>
                                                {ServicoItem &&
                                                    ServicoItem.sort((a, b) => a?.descricao?.localeCompare(b?.descricao))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.descricao}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Dono do Serviço</Form.Label>
                                            <Form.Select aria-label="Default select example" onChange={handleChange} name="cargoDonoKey">
                                                <option value="">Selecione</option>
                                                {Cargos &&
                                                    Cargos.sort((a, b) => a?.descricao?.localeCompare(b?.descricao))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.descricao}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Executor do Serviço</Form.Label>
                                            <SelectMultiplo
                                                className='input-width'
                                                options={paraOpcoes(Linhas, 'key', 'nome')}
                                                value={executorValue}
                                                onChange={comoEvento(executorOnChange)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo do Serviço</Form.Label>
                                            <Form.Select aria-label="Default select example" onChange={handleChange} name="tipoServicoKey">
                                                <option value="">Selecione</option>
                                                {TiposServico &&
                                                    TiposServico.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.nome.length > 120 ? item.nome.substring(0, 120) + '...' : item.nome}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Label>Empresas Atendidas</Form.Label>
                                        <SelectMultiplo
                                            className='input-width'
                                            options={paraOpcoes(Organizacoes, 'key', 'nome')}
                                            value={organizacaoValue}
                                            onChange={comoEvento(organizacaoOnChange)}
                                        />
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Local de Execução</Form.Label>
                                            <SelectMultiplo
                                                className='input-width'
                                                options={paraOpcoes(ServicoLocalidade, 'key', 'nome')}
                                                value={localidadeValue}
                                                onChange={comoEvento(localidadeOnChange)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Área Solicitante</Form.Label>
                                            <SelectMultiplo
                                                className='input-width'
                                                options={paraOpcoes(AreaServicoDisponivel, 'key', 'descricao')}
                                                value={areaValue}
                                                onChange={comoEvento(areaOnChange)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Método Solicitação</Form.Label>
                                            <Form.Select aria-label="Default select example" onChange={handleChange} name="metodoSolicitacaoKey">
                                                <option value="">Selecione</option>
                                                {Metodos &&
                                                    Metodos.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.nome.length > 120 ? item.nome.substring(0, 120) + '...' : item.nome}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="nivel" title={<span>Nível de Serviço</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Opção</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Valor</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>SLA de Atendimento</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Select aria-label="Default select example" onChange={handleChange} name="slaAtendimentoKey">
                                                <option value="">Selecione</option>
                                                {SLAs &&
                                                    SLAs.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.nome}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>SLA de Solução</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Select aria-label="Default select example" onChange={handleChange} name="slaSolucaoKey">
                                                <option value="">Selecione</option>
                                                {SLAs &&
                                                    SLAs.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.nome}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Periodicidade de Solicitação</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Select aria-label="Default select example" onChange={handleChange} name="periodicidadeKey">
                                                <option value="">Selecione</option>
                                                {Periodicidades &&
                                                    Periodicidades.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.nome.length > 120 ? item.nome.substring(0, 120) + '...' : item.nome}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Período de Cobertura</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Select aria-label="Default select example" onChange={handleChange} name="coberturaKey">
                                                <option value="">Selecione</option>
                                                {Coberturas &&
                                                    Coberturas.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.nome.length > 120 ? item.nome.substring(0, 120) + '...' : item.nome}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Práticas de Referência</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <SelectMultiplo
                                                className='input-width'
                                                options={paraOpcoes(Praticas, 'key', 'nome')}
                                                value={praticaValue}
                                                onChange={comoEvento(praticaOnChange)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Fornecedores</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <SelectMultiplo
                                                className='input-width'
                                                options={paraOpcoes(Fornecedores, 'key', 'fantasia')}
                                                value={fornecedorValue}
                                                onChange={comoEvento(fornecedorOnChange)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="obs" title={<span>Observações</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Objetivo do Serviço</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="objetivo" as="textarea" rows={3} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Escopo do Serviço</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="escopo" as="textarea" rows={3} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Exclusões</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} name="exclusoes" as="textarea" rows={3} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="anexos" title={<span>Anexos</span>}>
                                <div style={{ maxHeight: '450px', overflow: 'auto' }}>
                                    <div className='mb-3'>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Link</Form.Label>
                                            <Form.Control value={LinkAdd} maxLength={500} onChange={(e) => setLinkAdd(e.target.value)} name="links" />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição</Form.Label>
                                            <Form.Control value={DescricaoAdd} maxLength={500} as="textarea" rows={2} onChange={(e) => setDescricaoAdd(e.target.value)} name="descricaoLink" />
                                        </Form.Group>
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <button className="btn-dash btn-pesquisar" style={btnPesquisar} type="button" onClick={() => AdicionarLink()}><FaPlus style={{ marginRight: "5px" }} />Adicionar link</button>
                                        </div>
                                    </div>
                                    <div className="secao-link">
                                        {FormLink && FormLink?.map((item, index) => {
                                            return (
                                                <div key={item.keyLink} className="content-comentario">
                                                    <div style={{ width: '40%' }}>
                                                        <div className="div-comentario">
                                                            <p className="p-title">Usuário: </p>
                                                            <span>{item.nome}</span>
                                                        </div>
                                                        {moment(item.dataHora).format('L')} às {moment(item.dataHora).format('LT')}
                                                    </div>
                                                    <div className="div-link">
                                                        <p className="p-title">Link: </p>
                                                        <span><p className="p-content"><a href={item.link} target="_blank">{item.link}</a></p></span>
                                                    </div>
                                                    <div className="div-comentario">
                                                        <p className="p-title">Comentário: </p>
                                                        <span><p>{item.descricao}</p></span>
                                                    </div>
                                                    <div className="div-button">
                                                        <button type="button" className="btn-del" onClick={() => ExcluirLink(index)}><TbTrash /></button>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                    <hr />
                                    <div>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Anexos</Form.Label>
                                            <Form.Control type='file' onChange={(e) => setAddAnexo(e.target.files[0])} name="anexo" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.txt" ref={anexoRef} />
                                        </Form.Group>
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <button className="btn-dash btn-pesquisar" style={btnPesquisar} type="button" onClick={() => AdicionarAnexo()}><FaPlus style={{ marginRight: "5px" }} />Adicionar anexo</button>
                                        </div>
                                        <div style={{ display: 'flex', gap: '35px', flexWrap: 'wrap', maxHeight: '300px', overflow: 'auto' }} className="mb-3">
                                            {FormAnexoServico && FormAnexoServico?.map((item, index) => {
                                                return (
                                                    <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '180px' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <FaImage style={{ fontSize: '40px' }} />
                                                            <span style={{ wordBreak: 'break-word' }}>{item.fileName}</span>
                                                        </div>
                                                        <div className="div-button">
                                                            <button type="button" className="btn-del" onClick={() => ExcluirAnexo(index)}><TbTrash /></button>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="sistema" title={<span>Aplicação</span>}>
                                <h1 className='h1-modal'>Aplicações</h1>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '25px' }}>
                                    <Col xs={4}>
                                        <Form.Group>
                                            <Form.Select ref={sistemaRef} aria-label="Default select example" onChange={(e) => setSistemaKey(e.target.value)}>
                                                <option value="">Selecione</option>
                                                {Sistemas &&
                                                    Sistemas.sort((a, b) => a?.descricao?.localeCompare(b?.descricao))?.map((c) => {
                                                        return (
                                                            <option key={c.id} value={JSON.stringify(c)}>{c.nome}</option>
                                                        )

                                                    })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <button type="button" className="btn-dash btn-criar btn-add" style={btnCriar} onClick={() => AdicionarSistema()}><FaPlus /></button>
                                </div>
                                <hr />
                                <Row>
                                    <div style={{ minHeight: '30vh', maxHeight: '40vh', overflowY: 'auto', width: '100%' }}>
                                        {sistemasSelecionados.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    <div key={index} className="content-comentario">
                                                        <div className="div-comentario">
                                                            <SlOptionsVertical style={{ marginRight: '15px' }} />
                                                            <span><div dangerouslySetInnerHTML={{ __html: item.nome }} /></span>
                                                        </div>
                                                        <div className="div-button">
                                                            <button type="button" className="btn-del" onClick={() => ExcluirSistema(item.id)}><TbTrash /></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </Row>
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={handleClose}>Cancelar</button>
                        <button className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCadastrarServico